import { useEffect, useState } from 'react'
import {
  getStoredVersion,
  storeVersion,
  getOrDarwVersion,
  VersionID,
} from '../helpers/ab/abManager'

/**
 * Hook to determine the active A/B test version for this user.
 *
 * - Uses version from server (if provided), and persists it.
 * - If no server version, uses stored value or draws a new one.
 * - Avoids unnecessary state updates and localStorage writes.
 */
export const useVersion = (userVersion?: VersionID) => {
  const [version, setVersion] = useState<VersionID | null>(null)  // State to keep the active version

  // Run this when the component that uses this hook mounts, or when useVersion() is called (with a new userVersion)
  useEffect(() => {
    
    // Case 1: Server provides version, override storage and change state only if different
    if (userVersion !== undefined && userVersion !== null) {
      // Store in localStorage
      if (getStoredVersion() !== userVersion) {
        storeVersion(userVersion)
      }
      // Update state 
      if (version !== userVersion) {
        setVersion(userVersion)
      }
      return
    }

    // Case 2: No server version — use local or draw
    getOrDarwVersion().then((drawn) => {
      if (version !== drawn) {
        setVersion(drawn)
      }
    })
  }, [userVersion])

  return version
}